var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.174 21.561"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-682.665h22.174v21.565H0z",
    transform: "translate(-1.498 681.474)",
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star_inline_svg__a)",
    transform: "translate(1.498 1.192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.506 1.618A1.207 1.207 0 019.589.945a1.207 1.207 0 011.083.673l1.854 3.758a1.208 1.208 0 00.909.661l4.147.6a1.207 1.207 0 01.975.822 1.207 1.207 0 01-.306 1.238l-3 2.925a1.208 1.208 0 00-.347 1.069l.709 4.13a1.207 1.207 0 01-.48 1.181 1.208 1.208 0 01-1.272.092l-3.709-1.95a1.208 1.208 0 00-1.124 0l-3.709 1.95a1.208 1.208 0 01-1.272-.092 1.207 1.207 0 01-.48-1.181l.708-4.13a1.208 1.208 0 00-.347-1.069l-3-2.925a1.207 1.207 0 01-.305-1.238 1.207 1.207 0 01.975-.822l4.147-.6a1.208 1.208 0 00.909-.661z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

export default SvgStarinline;